import axios from 'axios'
import { StockAlert, StockAlertPostPayload } from 'src/core/models'


export async function getStockAlertListAPI(): Promise<StockAlert[]> {
  const url = '/api/v1/stock_alerts/'
  const { data } = await axios.get(url)
  return data?.results
}

export async function deleteStockAlertAPI(id: number) {
  const url = `/api/v1/stock_alerts/${id}/`
  const { data } = await axios.delete(url)
  return data
}

export async function createStockAlertAPI(payload: StockAlertPostPayload): Promise<StockAlert> {
  const url = `/api/v1/stock_alerts/`
  const { data } = await axios.post<StockAlert>(url, payload)
  return data
}
